import { Tooltip } from "react-tooltip";
import { FaCircleInfo } from "react-icons/fa6"
import { useState } from "react";
import RatingGuidance from "../justificationComponent/RatingGuidance";

const ScoreDistribution = ({ 
        project, 
        scoreDistribution, 
        ratingQuota, 
        totalActualScore, 
        countCalibrated, 
        deviationRating, 
        averageAllScore,
        businessPerformance
    }) => {
    
    const [showGuidanceRating, setShowGuidanceRating] = useState(false)
    const handleCloseGuidanceRating = () => setShowGuidanceRating(false)

    return(
        <div>
            <table className="table align-items-center">
                <thead>
                    <tr>
                        <th colSpan={2} className="text-center">Rating Scale</th>
                        <th className="text-center">Guidance
                            {/* <FaCircleInfo
                                fontSize={12}
                                className="ms-2"
                                style={{color: "#808080", cursor: "pointer"}}
                                data-tooltip-id="tooltip-guidance"
                            /> */}
                        </th>
                        <th className="text-center">Actual</th>
                        <th className="text-center">Calibrated</th>
                        <th className="text-center">Deviation Rating</th>
                        { isNaN(averageAllScore) || averageAllScore === 0 ? <></> : ( 
                        <th className="text-center">Avg.Score 
                            <FaCircleInfo
                                fontSize={12}
                                className="ms-2"
                                style={{color: "#808080", cursor: "pointer"}}
                                data-tooltip-id="tooltip-avgscore"
                            />
                        </th>
                        )}
                    </tr>
                    {/* <tr>
                        <th scope="col" className="text-center">Phase 1</th>
                        <th scope="col" className="text-center">Phase 2</th>
                    </tr> */}
                </thead>
                {
                    project ?
                    <tbody>
                        <tr>
                            <td className="text-center">A+</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.APlusLowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.APlusUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.APlusLowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.APlusUpperLimit}`
                                        : '-'}
                                </td>    
                            )}
                            <td className={`text-center ${project.APlusExcess?'':'required'}`}>
                                <FaCircleInfo
                                    fontSize={12}
                                    className="ms-2"
                                    style={{color: "#808080", cursor: "pointer"}}
                                    onClick={() => setShowGuidanceRating(true)}
                                />
                            </td>
                            <td className="text-center">{totalActualScore?.APlus ?? 0}</td>
                            <td className="text-center">{countCalibrated?.APlus ?? 0}</td>
                            <td className="text-center">{deviationRating?.APlus ?? 0}</td>
                            { isNaN(averageAllScore) || averageAllScore === 0 ? <></> : (
                                <td className="text-center" rowSpan={7}><p style={{fontSize: '32px'}}>{!isNaN(averageAllScore) ? averageAllScore.toFixed(2) : '0.00'}</p></td>
                            )}
                        </tr>   
                        <tr>
                            <td className="text-center">A</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.ALowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.AUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.ALowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.AUpperLimit}`
                                        : '-'}
                                </td>
                            )}
                            <td className={`text-center ${project.AExcess?'':'required'}`}>{ratingQuota?.A ?? 0}</td>
                            <td className="text-center">{totalActualScore?.A ?? 0}</td>
                            <td className="text-center">{countCalibrated?.A ?? 0}</td>
                            <td className="text-center">{deviationRating?.A ?? 0}</td>
                        </tr>   
                        <tr>
                            <td className="text-center">B+</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.BPlusLowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.BPlusUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.BPlusLowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.BPlusUpperLimit}`
                                        : '-'}
                                </td>
                            )}
                            <td className={`text-center ${project.BPlusExcess?'':'required'}`}>{ratingQuota?.BPlus ?? 0}</td>
                            <td className="text-center">{totalActualScore?.BPlus ?? 0}</td>
                            <td className="text-center">{countCalibrated?.BPlus ?? 0}</td>
                            <td className="text-center">{deviationRating?.BPlus ?? 0}</td>
                        </tr>   
                        <tr>
                            <td className="text-center">B</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.BLowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.BUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.BLowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.BUpperLimit}`
                                        : '-'}
                                </td>
                            )}
                            <td className={`text-center ${project.BExcess?'':'required'}`}>{ratingQuota?.B ?? 0}</td>
                            <td className="text-center">{totalActualScore?.B ?? 0}</td>
                            <td className="text-center">{countCalibrated?.B ?? 0}</td>
                            <td className="text-center">{deviationRating?.B ?? 0}</td>
                        </tr>   
                        <tr>
                            <td className="text-center">C</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.CLowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.CUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.CLowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.CUpperLimit}`
                                        : '-'}
                                </td>
                            )}
                            <td className={`text-center ${project.CExcess?'':'required'}`}>{ratingQuota?.C ?? 0}</td>
                            <td className="text-center">{totalActualScore?.C ?? 0}</td>
                            <td className="text-center">{countCalibrated?.C ?? 0}</td>
                            <td className="text-center">{deviationRating?.C ?? 0}</td>
                        </tr>   
                        <tr>
                            <td className="text-center">D</td>
                            {scoreDistribution && scoreDistribution.ScoreDistributions && scoreDistribution.ScoreDistributions[0] && (
                                <td className="text-center">
                                    {!isNaN(scoreDistribution?.ScoreDistributions[0]?.DLowerLimit) && !isNaN(scoreDistribution?.ScoreDistributions[0]?.DUpperLimit)
                                        ? `${scoreDistribution?.ScoreDistributions[0]?.DLowerLimit} - ${scoreDistribution?.ScoreDistributions[0]?.DUpperLimit}`
                                        : '-'}
                                </td>
                            )}
                            <td className={`text-center ${project.DExcess?'':'required'}`}>{ratingQuota?.D ?? 0}</td>
                            <td className="text-center">{totalActualScore?.D ?? 0}</td>
                            <td className="text-center">{countCalibrated?.D ?? 0}</td>
                            <td className="text-center">{deviationRating?.D ?? 0}</td>
                        </tr>   
                        <tr>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                            <td className="text-center">{ratingQuota?.Total ?? 0}</td>
                            <td className="text-center">{totalActualScore?.Total ?? 0}</td>
                            <td className="text-center">{
                                (countCalibrated?.APlus ?? 0) + (countCalibrated?.A ?? 0) + (countCalibrated?.BPlus ?? 0) + 
                                (countCalibrated?.B ?? 0) + (countCalibrated?.C ?? 0) + (countCalibrated?.D ?? 0)
                            }</td>
                            <td className="text-center">{
                                (deviationRating?.APlus ?? 0) + (deviationRating?.A ?? 0) + (deviationRating?.BPlus ?? 0) + 
                                (deviationRating?.B ?? 0) + (deviationRating?.C ?? 0) + (deviationRating?.D ?? 0)
                            }</td>
                        </tr>    
                    </tbody>:
                    <></>
                }
            </table>
            {/* <div className="flex-row"><p className="required"></p>: You should follow the guidance when calibrate the score</div> */}
            <Tooltip
                id="tooltip-avgscore"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "10rem"
                }}
            >
                <p>Average score of calibration results (for Berau Coal employees only)</p>
            </Tooltip>
            <Tooltip
                id="tooltip-guidance"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "15rem"
                }}
            >
                <p className="mb-0"><b>Business Performance: {businessPerformance?.BusinessUnit?.Name}</b></p>
                <p className="mb-0">A+ :{businessPerformance?.APlusQuota} %</p>
                <p className="mb-0">A  :{businessPerformance?.AQuota} %</p>
                <p className="mb-0">B+:{businessPerformance?.BPlusQuota}%</p>
                <p className="mb-0">B  :{businessPerformance?.BQuota}%</p>
                <p className="mb-0">C  :{businessPerformance?.CQuota}%</p>
                <p className="mb-0">D  :{businessPerformance?.DQuota}%</p>
            </Tooltip>
            {
                showGuidanceRating &&
                <RatingGuidance
                    show={showGuidanceRating}
                    handleClose={handleCloseGuidanceRating}
                />
            }
        </div>
    )
}

export default ScoreDistribution